module.exports = __webpack_public_path__ + "static/media/notification-approval.f7f51f58.svg";